// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tOvN4tsYAARUOu {
  margin-bottom: var(--ds-space-250, 19px);
  font-size: 24px;
  font-weight: var(--ds-font-weight-medium, 500);
  text-align: center;
}
.Vj2acFn4LUn4nT {
  margin-bottom: var(--ds-space-150, 12px);
  text-align: center;
}
.OpxGeA1Vk9trje {
  width: 750px;
  margin-bottom: var(--ds-space-150, 12px);
  text-align: center;
}
@media only screen and (max-width: 750px) {
  .tOvN4tsYAARUOu {
    font-size: 20px;
  }
  .Vj2acFn4LUn4nT {
    width: 320px;
  }
}
.msEiiGssB3fmjU {
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, ""]);
// Exports
export var header = `tOvN4tsYAARUOu`;
export var trelloDesc = `Vj2acFn4LUn4nT`;
export var ppDesc = `OpxGeA1Vk9trje`;
export var upgradeView = `msEiiGssB3fmjU`;
export default ___CSS_LOADER_EXPORT___;
